import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum QuoteTemplateSecurityRight {
    CanAccess = 28000,
    Manage = 28001,
}

export class QuoteTemplatesSecurityModule extends BaseSecurityModule<QuoteTemplateSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.QuoteTemplates,
            [
                { _id: QuoteTemplateSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: QuoteTemplateSecurityRight.Manage, name: 'Manage', basic: true },
            ] as SecurityRight<QuoteTemplateSecurityRight>[]
        );

        this.plan = TenantSubscription.Professional;
    }


}
